import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import SpokePage from "./SpokePage";
import { Star } from "./Star";
import { getGulfGuide, GUIDES_UPDATED, GUIDES_PUBLISHED } from "../../lib/gulfGuides";
import "./Editorial.css";

/* /candidates/guides/:slug — one country's jobseeker guide.
   Gated for review while GUIDES_PUBLISHED is false (PageSEO marks it noindex). */
export default function GuidePage() {
  const { slug } = useParams();
  const g = getGulfGuide(slug);
  if (!g) return <Navigate to="/candidates/guides" replace />;

  return (
    <SpokePage
      audience="candidate"
      eyebrow="Working in the Gulf"
      title={<>Working in <em>{g.country}.</em></>}
      intro={g.intro}
      next={{ label: "Submit your CV", to: "/candidates/apply" }}
    >
      {!GUIDES_PUBLISHED && (
        <section className="ed-band ed-band--sand ed-pad">
          <div className="ed-container">
            <p className="ed-stamp">Draft — figures pending final review before publishing.</p>
          </div>
        </section>
      )}

      {/* Key facts */}
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> {g.lede}</span>
            </div>
            <h2 className="ed-h2">What to expect, <em>in plain words.</em></h2>
          </header>
          <div className="faq-list">
            {g.facts.map((f) => (
              <div key={f.label} className="faq-item">
                <h3 className="faq-q">{f.label}</h3>
                <p className="faq-a">{f.body}</p>
              </div>
            ))}
          </div>
          {g.note && <p className="ed-caption" style={{ marginTop: 24 }}><b>Good to know:</b> {g.note}</p>}
        </div>
      </section>

      {/* Rights */}
      <section className="ed-band ed-band--sand ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> Your rights</span>
            </div>
            <h2 className="ed-h2">What protects you.</h2>
          </header>
          <ul className="ed-list">
            {g.rights.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
          <p className="ed-caption" style={{ marginTop: 28, display: "flex", gap: 10, alignItems: "flex-start" }}>
            <ShieldCheck size={18} strokeWidth={2} style={{ flex: "0 0 auto", marginTop: 2 }} />
            <span>
              Always confirm your agency is licensed before you pay anyone. Adel Group is
              NEA-licensed (RA/2025/09/56) — <Link to="/trust">see how to verify us</Link>.
              There is no registration fee to begin.
            </span>
          </p>
          <p className="ed-stamp">Last updated {GUIDES_UPDATED}</p>
        </div>
      </section>
    </SpokePage>
  );
}
